import axios from '../axios';

const customersAPI = {
  getAllCustomers: async () => {
    const response = await axios.get('/customers');
    return response.data;
  },

  getByNumber: async (custNum) => {
    const response = await axios.get(`/customers/${custNum}`);
    return response.data;
  },

  create: async (customerData) => {
    const response = await axios.post('/customers', customerData);
    return response.data;
  },

  update: async (custNum, customerData) => {
    const response = await axios.put(`/customers/${custNum}`, customerData);
    return response.data;
  },

  delete: async (custNum) => {
    const response = await axios.delete(`/customers/${custNum}`);
    return response.data;
  },

  search: async (query) => {
    const response = await axios.get(`/customers/search/${query}`);
    return response.data;
  },

  getByChargeDate: async (date) => {
    const response = await axios.get(`/customers/charge-date/${date}`);
    return response.data;
  }
};

export default customersAPI; 